"use client";

import Image from "next/image";
import LeftArrowWhiteCircleIcon from "~/icons/left-arrow-white-circle.svg";
import styles from './SpecializationMbaCard.module.scss'
import Markdown from "@/components/atoms/Markdown";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";
import Carousel from "../CustomCarousels/Carousel";
import { IModalActions, ModalTypes } from "@/types/modal";
import { useModalDispatch } from "@/context/ModalContext";


type Specialization = {
  Image?: {
    enabled: boolean;
    source?: {
      data?: Array<{ attributes: { url: string } }>;
    };
    alt?: string;
    url?: string;
    title?: string;
  };
  Title?: {
    enabled: boolean;
    text: string;
  };
  SponsoredImage?: {
    data?: {
      attributes: {
        url: string;
      };
    };
  };
};

export function SpecializationCardMba({
  SlideContent,
  index,
  associatedSpecialization
}: {
  SlideContent: Specialization;
  index?: number;
  associatedSpecialization?: any
}) {

  const title = SlideContent?.Image?.title?.replace(/\n/gi, "  \n");
  const modalDispatch = useModalDispatch();

  const GAEventsHandler = () => {

    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalLP,
        modalData: { associatedPrograms:[associatedSpecialization],isLandingPage:true },
      },
    });
    pushToDataLayer({
      'event': 'card_interaction',
      'cta_text': title,
      'section_name': 'Key Specializations',
      'page_type': getGlobalStateValue('pageType')
    });
  }
  return (
    <div id={`specialization-card-${index}`}
      className={`${styles.SpecializationCard__background} flex flex-col justify-between`}
    >
      {SlideContent?.Image?.enabled && (
        <div className={`${styles.SpecializationCard__InnerImage}, flex justify-between`}>
          <Image
            src={SlideContent?.Image?.source?.data?.[0]?.attributes?.url}
            alt={SlideContent?.Image?.alt || 'Specialization Card'}
            width={60}
            height={60}
            title="Specialization Card"
          />
          {SlideContent?.SponsoredImage?.data?.attributes?.url && (
            <div className={styles['sponsored-image-wrapper']}>
              <Image
                src={SlideContent?.SponsoredImage?.data?.attributes.url}
                alt="logo"
                width={80}
                height={60}
                title="logo"
                className={styles['sponsored-image']}
              />
            </div>
          )
          }
        </div>
      )}

      <div className="flex items-center justify-between gap-2">
          <h3 className={`${styles.SpecializationCard__InnerTitle} font-semibold`}>
            <Markdown>
              {title}
            </Markdown>
          </h3>
            <div
              className={`shrink-0 ${styles.SpecializationCard__InnerShowMoreIcon}
        font-semibold`}
            >
              <Image  onClick={GAEventsHandler} src={LeftArrowWhiteCircleIcon} alt="show more" title="show more" />
            </div>
      </div>
    </div>
  );
}

export default function SpecializationCarouselMba({
  associatedSpecialization,
}: {
  associatedSpecialization?: any
}) {

  return (
    <div id="Carousel">
      <Carousel
      id = "KeySpecializations"
          children={associatedSpecialization?.map((slideContent: SpecializationAttributes, index: number) => (
          <div key={index} className={styles.specialCardWrapper}>
            <SpecializationCardMba associatedSpecialization={associatedSpecialization[index]}  SlideContent={slideContent.attributes} index={index}/>
          </div>
        ))}
        config={{
          spaceBetween: 20,
          autoplay: {
            delay: 2000
          },
          speed: 500,
          pagination: {
            className: "program_detail_carousel_pagination text-center my-5",
          },
          breakpoints: {
            320: {
              slidesPerView: 1.1,
            },
            481: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 3.1,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 5,
              spaceBetween: 25,
            },
            1900: {
              slidesPerView: 5,
              spaceBetween: 30,
            },
            2560: {
              slidesPerView: 5,
              spaceBetween: 40,
            }
          },
        }}
        className={styles.specializationsCarousel}
      />
    </div>
  );
}
